"use client";

import { TopBar, TopNavBar, Footer } from '@/layout';
import Hero from './components/Hero';
import ShowHotels from './components/ShowHotels';
import HoteliersSection from './components/HoteliersSection';
import { useBookPage } from '@/hooks/useBookPage';
import { useBookPageSectionFlags } from '@/hooks/useBookPageSectionFlags';

const Hotels = () => {
  const { section } = useBookPage('hotels_intro');
  const { flags: hotelsIntroFlags } = useBookPageSectionFlags('hotels_intro');
  const introIsActive =
    section?.is_active === undefined ||
    section?.is_active === 1 ||
    section?.is_active === "1" ||
    section?.is_active === true;
  const showHero = Boolean(section) && introIsActive;
  const applyTopOffset = !showHero;
  const defaultListTitle = 'Selected Hotels in East Crete';
  const defaultListIntro =
    'Discover handpicked hotels across East Crete, carefully selected to match different travel styles, preferences, and expectations for every type of guest.';
  const listTitle = !showHero
    ? (hotelsIntroFlags?.title?.trim() || defaultListTitle)
    : defaultListTitle;
  const listIntro = !showHero
    ? (hotelsIntroFlags?.intro_text?.trim() || defaultListIntro)
    : defaultListIntro;

  return (
    <>
      <TopBar />
      <TopNavBar />

      <main>
        {showHero && <Hero section={section} />}
        <ShowHotels
          applyTopOffset={applyTopOffset}
          usePrimaryHeading={!showHero}
          title={listTitle}
          introText={listIntro}
        />
        <HoteliersSection />
      </main>

      <Footer />
    </>
  );
};

export default Hotels;
